export const routes = {
    DEFAULT: '/',
    CURRENT_DATA: '/current-data',
    METADATA: '/metadata',
} as const;
